import type { EducationItem } from '@/types';

/** Education records from Muhammad_Sufyan_Malik.pdf */
export const education: EducationItem[] = [
  {
    id: 'atilim',
    institution: 'Atılım University, Ankara',
    degree: "Master's Degree — MS (Software Engineering)",
    startYear: '2018',
    endYear: '2020',
    details: [
      'Software Engineering',
      'Software Testing',
      'Big Data',
      'Machine Learning',
      'Research Methodology',
      'Thesis: Use of Optimization Techniques for Health Prediction',
    ],
  },
  {
    id: 'comsats',
    institution: 'COMSATS University Islamabad',
    degree: 'Bachelor of Science — BS (Software Engineering)',
    startYear: '2013',
    endYear: '2017',
    details: [
      'Software Engineering',
      'Software Requirements Engineering',
      'Software Design',
      'Data Structures',
      'Software Testing',
      'Final Year Project: Colorimetric Analysis (Android)',
    ],
  },
  {
    id: 'iba-fsc',
    institution: 'IBA Community College Khairpur',
    degree: 'FSC (Pre-Engineering)',
    startYear: '2010',
    endYear: '2013',
    details: ['English', 'Mathematics', 'Physics', 'Chemistry', 'Urdu'],
  },
  {
    id: 'iba-matric',
    institution: 'IBA Community College Khairpur',
    degree: 'Matriculation',
    startYear: '2009',
    endYear: '2011',
    details: ['English', 'Mathematics', 'Physics'],
  },
];
